var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('a',{attrs:{"href":"https://lixvyang.github.io/"}},[_vm._v("Mixin:39427696")])])])}]

export { render, staticRenderFns }